import { useEffect, useRef, useState } from "react";
import { IconChevronDown, IconX, IconCheck } from "@tabler/icons-react";
import styles from "./searchmodal.module.css";

export default function SkillsMultiSelect({
  allSkills,
  selected = "",
  onChange,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const selectedSkills = selected
    ? selected
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
    : [];

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target))
        setOpen(false);
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [open]);

  const toggleSkill = (skill) => {
    let next;

    if (selectedSkills.includes(skill)) {
      next = selectedSkills.filter((s) => s !== skill);
    } else {
      next = [...selectedSkills, skill];
    }

    onChange(next.join(","));
  };

  return (
    <div className={styles.multiWrap} ref={wrapRef}>
      <div
        className={`${styles.multiTrigger} ${
          selectedSkills?.length ? styles.multiTriggerHasValue : ""
        } ${open ? styles.multiTriggerOpen : ""}`}
        tabIndex={0}
        onClick={() => setOpen((o) => !o)}
      >
        {selectedSkills?.length === 0 ? (
          <span>Select skills</span>
        ) : (
          selectedSkills?.map((s) => (
            <span key={s} className={styles.multiChip}>
              {s}
              <span
                className={styles.multiChipRemove}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleSkill(s);
                }}
              >
                <IconX size={11} />
              </span>
            </span>
          ))
        )}
        <IconChevronDown
          size={18}
          className={`${styles.multiChevron} ${open ? styles.multiChevronOpen : ""}`}
        />
      </div>

      {open && (
        <div className={styles.multiPanel}>
          {allSkills.map((s) => {
            const isSelected = selectedSkills.includes(s);
            return (
              <div
                key={s}
                className={`${styles.multiOption} ${isSelected ? styles.multiOptionSelected : ""}`}
                onClick={() => toggleSkill(s)}
              >
                <span className={styles.optBox}>
                  {isSelected && <IconCheck size={12} />}
                </span>
                {s}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
